import React from 'react';
import BackButton from './BackButton';

const Merch = () => {
	return (
		<div>
			<BackButton />
			<div className="ui inverted centered header" style={{ fontFamily: 'Gothic', fontWeight: 100, fontSize: '3em' }}>coming soon</div>
		</div>
	);
};

export default Merch;